/* eslint-disable no-console */
import type { App } from 'vue';
import { useAppVersion } from '@/composables/use-app-version';

export const VersionPlugin = {
   install: (app: App) => {
      const { version, buildTime } = useAppVersion();

      app.config.globalProperties.$version = version;
      app.config.globalProperties.$buildTime = buildTime;

      // Also provide it for composition API
      app.provide('appVersion', version);
      app.provide('buildTime', buildTime);

      // Log version info on startup
      const v = version.value || 'unknown';
      const t = buildTime.value ? new Date(buildTime.value).toLocaleString() : 'unknown';

      console.log(
         `%c📦 Apaluma Frontend v${v}`,
         'background: #1a1a2e; color: #00ff00; font-weight: bold; font-size: 14px; padding: 8px 12px; border-radius: 4px; font-family: monospace',
      );
      console.log(
         `%c  Built: ${t}`,
         'color: #888; font-family: monospace; font-size: 12px',
      );
   },
};
